document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('[data-tenet-fot-popup]').forEach((popup) => {
    if (popup.dataset.tenetPopupReady === 'true') return;

    const intro = popup.querySelector('[data-popup-intro]');
    const signup = popup.querySelector('[data-popup-signup]');
    const revealButton = popup.querySelector('[data-popup-reveal-form]');
    const backButton = popup.querySelector('[data-popup-back]');
    const form = popup.querySelector('[data-popup-form]');
    const section = popup.closest('.shopify-section');
    const teaser = section?.querySelector('[data-popup-teaser]');
    const teaserOpenButton = teaser?.querySelector('[data-popup-teaser-open]');
    const teaserCloseButton = teaser?.querySelector('[data-popup-teaser-close]');

    const success = popup.querySelector('[data-popup-success]');
    const error = popup.querySelector('[data-popup-error]');
    const copyButton = popup.querySelector('[data-popup-copy]');

    const popupFilledKey = 'theme:popup-filled';
    const popupAppearedKey = 'theme:popup-appeared';
    const teaserDismissedKey = 'theme:popup-teaser-dismissed';
    // The signup endpoint redirects back with ?newsletter=success|error. This flag ties
    // that redirect to a popup submission so footer signups don't reopen the popup.
    const popupSubmittedKey = 'tenet:popup-submitted';
    const submissionMaxAgeMs = 15 * 60 * 1000;

    const showSignup = () => {
      intro.hidden = true;
      if (success) success.hidden = true;
      signup.hidden = false;
      signup.querySelector('input[type="email"]')?.focus();
    };

    const showIntro = () => {
      signup.hidden = true;
      if (success) success.hidden = true;
      intro.hidden = false;
      revealButton?.focus();
    };

    const showSuccess = () => {
      intro.hidden = true;
      signup.hidden = true;
      success.hidden = false;
    };

    const canShowTeaser = () => (
      localStorage.getItem(popupFilledKey) !== 'true'
      && localStorage.getItem(teaserDismissedKey) !== 'true'
    );

    const showTeaser = () => {
      if (!teaser || !canShowTeaser()) return;
      teaser.hidden = false;
    };

    const hideTeaser = () => {
      if (teaser) teaser.hidden = true;
    };

    revealButton?.addEventListener('click', showSignup);
    backButton?.addEventListener('click', showIntro);
    form?.addEventListener('submit', () => {
      localStorage.setItem(popupFilledKey, 'true');
      try {
        sessionStorage.setItem(popupSubmittedKey, String(Date.now()));
      } catch {
        // Without session storage the signup still works; the code just won't be shown.
      }
      hideTeaser();
    });

    copyButton?.addEventListener('click', async () => {
      const code = popup.querySelector('[data-popup-code]')?.textContent.trim();
      if (!code) return;
      try {
        await navigator.clipboard.writeText(code);
        copyButton.textContent = 'Copied';
      } catch {
        const range = document.createRange();
        range.selectNodeContents(popup.querySelector('[data-popup-code]'));
        window.getSelection()?.removeAllRanges();
        window.getSelection()?.addRange(range);
        copyButton.textContent = 'Selected';
      }
    });

    popup.addEventListener('dialog:before-show', hideTeaser);
    popup.addEventListener('dialog:after-hide', showTeaser);

    teaserOpenButton?.addEventListener('click', () => {
      showIntro();
      hideTeaser();
      popup.show();
    });

    teaserCloseButton?.addEventListener('click', () => {
      localStorage.setItem(teaserDismissedKey, 'true');
      hideTeaser();
    });

    const signupResult = () => {
      const url = new URL(window.location.href);
      const result = url.searchParams.get('newsletter');
      if (result !== 'success' && result !== 'error') return null;
      let submittedAt = 0;
      try {
        submittedAt = Number(sessionStorage.getItem(popupSubmittedKey));
        sessionStorage.removeItem(popupSubmittedKey);
      } catch {
        return null;
      }
      if (!submittedAt || Date.now() - submittedAt > submissionMaxAgeMs) return null;
      url.searchParams.delete('newsletter');
      url.hash = '';
      window.history.replaceState(window.history.state, '', url.toString());
      return result;
    };

    const result = success ? signupResult() : null;
    if (result) {
      if (result === 'success') {
        showSuccess();
      } else {
        localStorage.removeItem(popupFilledKey);
        showSignup();
        if (error) error.hidden = false;
      }
      hideTeaser();
      window.customElements.whenDefined('newsletter-popup').then(async () => {
        await popup.show();
        (result === 'success' ? copyButton : signup.querySelector('input[type="email"]'))?.focus();
      });
    } else if (localStorage.getItem(popupAppearedKey) === 'true') {
      showTeaser();
    }

    popup.dataset.tenetPopupReady = 'true';
  });
});
